import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = [
    'menu',
    'menuButton',
    'menuMinimizeButton'
  ];
  static values = {};

  connect() {
    if (localStorage.getItem('menuMinimized')) {
      this.element.classList.add('menu-minimized');
    }
  }

  toggleNav() {
    this.element.classList.toggle('menu-open');
    this.menuButtonTarget.classList.toggle('active');
  }

  minimizeNav() {
    if (this.element.classList.contains('menu-minimized')) {
      this.element.classList.remove('menu-minimized');
      localStorage.removeItem('menuMinimized');
    } else {
      this.element.classList.add('menu-minimized');
      localStorage.setItem('menuMinimized', true);
    }
  }
}